// Mirrors trpc.rota.templates (apps/web/src/api/trpc/routers/rota.ts).

export type Slot = { role_id: number; headcount: number };

export type Block = {
  id?: number;
  name: string | null;
  start_time: string;
  end_time: string;
  break_minutes: number;
  slots: Slot[];
};

export type DayTemplate = {
  id: number;
  name: string;
  code: string | null;
  color: string | null;
  slot_count: number;
  blocks: (Block & { id: number })[];
};

export type Templates = {
  templates: DayTemplate[];
  weekdays: { weekday: number; template_id: number }[];
};

/** "ST" from "Standard day" when no code is set. */
export const templateCode = (tpl: Pick<DayTemplate, "name" | "code">) =>
  tpl.code ||
  tpl.name
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase() ||
  "—";

/** Minutes a block lasts (past midnight when end ≤ start), minus its break. */
export function blockMinutes(b: Pick<Block, "start_time" | "end_time" | "break_minutes">) {
  const [sh, sm] = b.start_time.split(":").map(Number);
  const [eh, em] = b.end_time.split(":").map(Number);
  let mins = eh * 60 + em - (sh * 60 + sm);
  if (mins <= 0) mins += 24 * 60;
  return Math.max(mins - (b.break_minutes || 0), 0);
}
